export const COVID_19_NEWS =
  'https://otetsutabi.notion.site/3ac6574dc87746a3a4f49ab2206f2fca';
export const LOCAL_DELIVERY = 'https://otetsutabi.com/features/localdelivery';
